module.exports = __webpack_public_path__ + "static/media/location-question.05bfc669.svg";